import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase';
import { useNavigate } from 'react-router-dom';
import './UsefulToolsPage.css';

function UsefulToolsPage() {
  const [pages, setPages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchPages();
  }, []);

  const fetchPages = async () => {
    try {
      setIsLoading(true);
      const pagesRef = collection(db, 'pages');
      const q = query(pagesRef, where('isActive', '==', true));
      const snapshot = await getDocs(q);
      
      const pagesData = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      
      setPages(pagesData);
    } catch (error) {
      console.error('Error fetching pages:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePageClick = (page) => {
    // Check if this is the Currency Converter and use dedicated page
    if (page.title && page.title.toLowerCase().includes('currency converter')) {
      navigate('/tools/currency-converter');
    } else {
      navigate(`/page/${page.id}`);
    }
  };

  if (isLoading) {
    return (
      <div className="tools-page">
        <div className="tools-loading">
          <div className="spinner"></div>
          <p>Loading tools...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="tools-page">
      <div className="tools-header">
        <h1>Useful Tools</h1>
        <p className="tools-subtitle">Everything you need for your visit to the Cook Islands</p>
      </div>

      {pages.length === 0 ? (
        <div className="no-pages">
          <p>📋 No tools available at the moment.</p>
          <p className="no-pages-subtitle">Check back soon for helpful resources!</p>
        </div>
      ) : (
        <div className="tools-grid">
          {pages.map((page) => (
            <div 
              key={page.id} 
              className="tool-card"
              onClick={() => handlePageClick(page)}
            >
              {page.heroImageUrl ? (
                <div className="tool-image-wrapper">
                  <img 
                    src={page.heroImageUrl} 
                    alt={page.title}
                    className="tool-image"
                  />
                  <div className="tool-overlay"></div>
                </div>
              ) : (
                <div className="tool-placeholder">
                  <span className="tool-icon">{page.title.charAt(0).toUpperCase()}</span>
                </div>
              )}
              
              <div className="tool-content">
                <h3>{page.title}</h3>
                {page.subtitle && <p className="tool-subtitle">{page.subtitle}</p>}
              </div>
              
              <div className="tool-arrow">→</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default UsefulToolsPage;
